import media from "./media";
import React, { useState } from "react";
import { useParams, useNavigate } from "react-router";



function BookPage(props) {
  
    const { id }= useParams();
    const selectedMedia = media.find(obj => obj.id === id);
    let navigate = useNavigate();
    // console.log("bookpage")


    return (
      <div className='site-container'>
        
          <div className={'page-controller-blue'}>

         <div id="bookpage-wrapper-1">
          <div className="bookpage-container-container-orwhatever">

       <div className= {'bookpage-wrapper'}> 
            <button className="x-close-bookpage" onClick={()=>navigate("/library")}>{'<'}─ back to library</button> 
          
          <div className="bookpage-container">

        <  img className="bookpage-img" src = {selectedMedia.thumbnail}></img>
          <div id="library-description">

            <div id='desc-contents'>

                <div className="media-tags">
                    {selectedMedia.tags.map((tag, index) =>
                    <>

                        <p className="media-tag">{tag} </p>
                        {(index < selectedMedia.tags.length - 1) ? <p>⊹</p> : ""}
                    </>

                    )}

                </div>
                <p id="media-title">{selectedMedia.title}</p>
                <p id="media-author"> ☽ .* :☆ﾟ.   ──────   by<b>{selectedMedia.author}</b></p>
                <p id="media-translator" style={{ display: selectedMedia.translated ? 'block' : 'none' }}>translation by: {selectedMedia.translator}</p>
                
                {(Object.hasOwn(selectedMedia, 'quote')) ?
                <div className="media-quote">
                  <p>{selectedMedia.quote}</p>
                </div>
                :  ''}
                
                <div className="media-description">
                  {selectedMedia.long_desc.map((paragraph, index) =>
                  <>
                  <p>{paragraph}</p>
                  {(index < selectedMedia.long_desc.length - 1) ? <br/> : ""}
                  </>
                  )}
                </div>
                
                <div className="media-links-container">
                    <p>─── ⋅ ∙ ∘  Access at:   ∘ ⋅ ⋅ ───</p>
                    <div className="media-links">
                    {selectedMedia.links.map((link, index) =>
                    <div className="media-link">
                        <p>⋅⊱</p>
                        <a  target="_blank" rel="noopener noreferrer" href={link.source}>{link.title}</a>
                    </div>
                    
                    )}
                </div>
                </div>
                
              </div>
            </div>

          </div>
           {/* If object has a gallery, display it: */}
                {(Object.hasOwn(selectedMedia, 'gallery')) ?
                    <div className="gallery">
                        {selectedMedia.gallery.map(item =>
                            <div className="book-gallery-item">
                            {(item.type == 'img') ?
                                <img src={item.src}></img>

                            : ""}
                            {(item.type == 'video') ?
                                <video controls>
                                    <source src={item.src} type="video/mp4" />

                                    </video>

                            : ""}
                            </div>
                            )}
                    </div>
                
                :""}
          </div>
          </div>
          </div>
          </div>
    </div>
          
    );
  }

  export default BookPage;